// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"708":"953eb3a2","863":"c56274fb","894":"dd8d702b"}[chunkId] + ".css";
};